import React from 'react';
import { PapiGallection, PapiDeviation } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import {
  BiData,
  BiContextProvidedValue,
  ItemClickBiEvent,
} from '@wix/da-bi/pkg/events';
import DeviationSidebarGrid from '../../../_partials/DeviationSidebarGrid';
import ContentByUser from '../../../_partials/ContentByUser';
import { ResourceType } from '../../../../types/resource';
import s from './CollectionBlock.scss';

interface Props {
  parentDeviation: PapiDeviation;
  collection: PapiGallection;
  deviations: PapiDeviation[];
}

const CollectionBlock: React.FC<React.PropsWithChildren<Props>> = ({
  collection,
  deviations,
  parentDeviation,
}) => {
  return (
    <BiLoggerContextProvider
      value={{
        sectionid: collection.folderId,
      }}
    >
      <div className={s['collection-header']}>
        <ContentByUser
          contentUrl={Url.userGalleryLink({
            username: collection.owner.username,
            gallectionType: 'collection',
            folderId: collection.folderId,
            folderName: collection.name,
            anchor: true,
          })}
          contentTitle={collection.name}
          biData={BiData<ItemClickBiEvent>({
            evid: 100,
            sectionname: 'collections',
            typeid: ResourceType.COLLECTION,
            itemid: collection.folderId,
            page_typeid: BiContextProvidedValue,
            page_itemid: BiContextProvidedValue,
          })}
        />
      </div>
      <DeviationSidebarGrid
        streamId={`devpage-sidebar-collections-${parentDeviation.deviationId}-${collection.folderId}`}
        parentDeviation={parentDeviation}
        deviations={deviations}
        maxRows={1}
      />
    </BiLoggerContextProvider>
  );
};
CollectionBlock.displayName = 'CollectionBlock';

export default CollectionBlock;
